
import { Component, Provide, Vue, Watch } from 'vue-property-decorator'
import ListItem from '@xt/www/components/business/about/ListItem.vue'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'
import { dataSource_about } from '@xt/client'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  name: 'PageAbout',
  // 每次进入页面都会调用
  // async fetch(ctx) {
  //   ctx.store.$storeAbout.onGetTypelist();
  // },
  components: {
    ListItem,
    InfiniteLoading
  }
})
export default class PageView extends Vue {
  defaultActiveKey = '1'
  activeKey = lodash.get(this.$route.query, 'active', this.defaultActiveKey)

  get PageStore() {
    return this.$store.$storeAbout
  }
  get pagePagination() {
    return this.$store.$storeAbout.pagePagination
  }
  get body() {
    return { type: this.activeKey }
  }
  get tabPane() {
    return dataSource_about
  }
  tabsChange(activeKey) {
    this.activeKey = activeKey

    this.PageStore.pagePagination.clearData()
  }

  mounted() {}

  updated() {}

  destroyed() {}
}
